module.exports = __webpack_public_path__ + "img/423.5f996f96.jpg";